import React, { memo } from "react";
import { ChevronLeft } from "lucide-react";

const CollapseToggle = ({ collapsed, onClick }) => (
  <button
    type="button"
    className={
      collapsed
        ? "sb-sidebar__collapse sb-sidebar__collapse--rotated"
        : "sb-sidebar__collapse"
    }
    onClick={onClick}
    aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
    aria-expanded={!collapsed}
  >
    <ChevronLeft size={16} />
  </button>
);

export default memo(CollapseToggle);
